import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RevolutionizeYourHardscapeBusiness from "./sections/RevolutionizeYourHardscapeBusiness";
import TheClifrockAdvantage from "./sections/TheClifrockAdvantage";
import ProvenOnNationalMedia from "./sections/ProvenOnNationalMedia";
import ContractorGrowthOpportunities from "./sections/ContractorGrowthOpportunities";
import EngineeredForEfficiency from "./sections/EngineeredForEfficiency";
import MasterpieceProjectGallery from "./sections/MasterpieceProjectGallery";
import StartYourPartnership from "./sections/StartYourPartnership";
import Hero from "./sections/Hero";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RevolutionizeYourHardscapeBusiness />
      <TheClifrockAdvantage />
      <ProvenOnNationalMedia />
      <ContractorGrowthOpportunities />
      <EngineeredForEfficiency />
      <MasterpieceProjectGallery />
      <StartYourPartnership />
      <Hero />
      <Footer />
    </div>;
}